import {createAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {
    signalAssetEvents,
    traderStrategies,
    traderStrategySignalAssets, traderStrategySignalEventOrders,
    traderStrategySignalEvents,
    traderStrategySignalStrategies
} from '../../services/apiService'

export const traderStrategySignalsSlice = createSlice({
    name: 'traderStrategySignals',
    initialState: {
        loading : false,
        signalEvents: [],
        pagination : {
            showSizeChanger:false,
            total: 0,
            pageSize: 20,
            current: 0
        },
        strategies: [],
        selectedStrategies: [],
        assets: [],
        selectedAssets: [],
        orders: {},
        loadingOrders: {}
    },
    reducers: {
        updatePagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        updateSelectedStrategies: (state, action) => {
            state.selectedStrategies = action.payload;
        },
        updateSelectedAssets: (state, action) => {
            state.selectedAssets = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadTraderStrategySignals.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(loadTraderStrategySignals.fulfilled, (state, action) => {
                const {content: signals = [], pageable: page, totalElements} = action.payload;
                const pagination = {
                    total: totalElements,
                    pageSize: page.pageSize,
                    current: page.pageNumber + 1
                };
                state.signalEvents = signals;
                state.pagination = pagination;
                state.loading = false;
            })
            .addCase(loadTraderStrategySignals.rejected, (state, action) => {
                state.signalEvents = [];
                state.loading = false;
            })
            .addCase(loadStrategies.fulfilled, (state, action) => {
                state.strategies = action.payload;
            })
            .addCase(loadAssets.fulfilled, (state, action) => {
                state.assets = action.payload;
            })
            .addCase(loadOrders.pending, (state, action) => {
                const eventId = action.meta.arg;
                state.loadingOrders = {
                    ...state.loadingOrders,
                    [eventId]: true
                };
            })
            .addCase(loadOrders.fulfilled, (state, action) => {
                const { eventId, orders } = action.payload;
                state.orders = {
                    ...state.orders,
                    [eventId]: orders
                };
                state.loadingOrders = {
                    ...state.loadingOrders,
                    [eventId]: false
                }
            })
            .addCase(loadOrders.rejected, (state, action) => {
                const eventId = action.meta.arg;
                state.loadingOrders = {
                    ...state.loadingOrders,
                    [eventId]: false
                };
            })
    }
})

export const { updatePagination, updateSelectedStrategies, updateSelectedAssets } = traderStrategySignalsSlice.actions;

export const loadTraderStrategySignals = createAsyncThunk('traderStrategySignals/loadTraderStrategySignals', ({pagination, selectedStrategies, selectedAssets}) => {
    return traderStrategySignalEvents(pagination, selectedStrategies, selectedAssets);
})

export const loadStrategies = createAsyncThunk('traderStrategySignals/loadStrategies', () => {
    return traderStrategySignalStrategies();
})

export const loadAssets = createAsyncThunk('traderStrategySignals/loadAssets', () => {
    return traderStrategySignalAssets();
})

export const loadOrders = createAsyncThunk( 'traderStrategySignals/loadOrders', (eventId, {rejectWithValue}) => {
    return traderStrategySignalEventOrders(eventId)
        .then(result => {
            return({eventId, orders: result})
        })
        .catch(error => {
            return rejectWithValue(error.response?.data || error.message);
        });
});


export default traderStrategySignalsSlice.reducer

